export default __webpack_public_path__ + "static/media/Nerdi.84821a92.gif";